/**
 * Route: /admin/audit-log — read-only audit trail browser.
 *
 * Admin-only. Shows an EmptyState when there are no audit events.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

import { me } from '../../lib/auth';
import { toast } from '../../lib/toast';
import { AuditLogScreen } from '../../features/admin/AuditLogScreen';

export const Route = createFileRoute('/admin/audit-log')({
  beforeLoad: async () => {
    try {
      const profile = await me();
      if (profile.platform_role !== 'admin') {
        toast({
          tone: 'error',
          message: 'Alleen admins hebben toegang tot deze pagina.',
        });
        throw redirect({ to: '/' });
      }
    } catch (err) {
      if (err && typeof err === 'object' && 'to' in err) {
        throw err;
      }
      throw redirect({ to: '/login' });
    }
  },
  component: AuditLogScreen,
});
